/**
 * مبدأِ پول — «حسابِ دفتر» (پیش‌فرض، موجودی ندارد) یا یکی از صندوق‌های تنخواه.
 *
 * خواستهٔ کاربر (۱۴۰۵/۰۶/۲۱): «مبدأش پیش‌فرض از حسابِ دفتر باشه ولی بتونیم از حسابِ
 * تنخواه هم پرداختی انجام بدیم که اتوماتیک خودش تو تنخواه بشینه، لازم نباشه دو بار
 * سند ثبت کنیم.» مقدارِ کنترل همان دو فیلدی است که سرور می‌خواهد:
 * `{ source_account: "office" | "petty", petty_account_id }`.
 */
import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { getPettyAccounts } from "../api/client";

let cache = null;
let inflight = null;
/** فهرستِ صندوق‌ها یک‌بار خوانده و بینِ همهٔ کنترل‌ها مشترک می‌شود. */
export function loadPettyAccounts(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (!inflight) {
    inflight = getPettyAccounts({ include_inactive: false })
      .then((r) => { cache = r.data || []; inflight = null; return cache; })
      .catch(() => { inflight = null; return cache || []; });
  }
  return inflight;
}

export const OFFICE = { source_account: "office", petty_account_id: null };

export function encodeSource(v) {
  return v?.source_account === "petty" && v.petty_account_id ? `petty:${v.petty_account_id}` : "office";
}
export function decodeSource(s) {
  if (typeof s === "string" && s.startsWith("petty:")) {
    return { source_account: "petty", petty_account_id: Number(s.slice(6)) };
  }
  return { ...OFFICE };
}
/** مبدأِ یک ردیفِ سرور (source_account/petty_account_id) به مقدارِ کنترل */
export function sourceOf(row) {
  if (!row) return { ...OFFICE };
  return row.source_account === "petty" && row.petty_account_id
    ? { source_account: "petty", petty_account_id: row.petty_account_id } : { ...OFFICE };
}
export function sourceLabel(src, pettyId, accounts) {
  if ((src || "office") !== "petty") return "حساب دفتر";
  const a = (accounts || cache || []).find((x) => x.id === pettyId);
  return a ? `تنخواه: ${a.name}` : "تنخواه";
}

export default function SourceSelect({ value, onChange, style, size, disabled }) {
  const [accounts, setAccounts] = useState(cache || []);
  useEffect(() => { loadPettyAccounts().then(setAccounts); }, []);
  const opts = [
    { value: "office", label: "حساب دفتر (پیش‌فرض)" },
    ...accounts.map((a) => ({ value: `petty:${a.id}`, label: `تنخواه: ${a.name}` })),
  ];
  return (
    <Select size={size} disabled={disabled} style={{ minWidth: 200, ...style }}
      value={encodeSource(value)} options={opts}
      onChange={(s) => onChange && onChange(decodeSource(s))} />
  );
}
